<template>
  <div class="requests-filter-by-date">
    <p class="requests-filter-by-date__title">
      {{ $t('withdrawal.period') }}
    </p>
    <DatePicker
        class="requests-filter-by-date__date"
        type="date"
        :showSecond="false"
        range
        confirm
        :confirm-text="select_dates"
        value-type="date"
        v-model="dates"
        @confirm="selectDates"
        @clear="clearDates"
        :lang="selectLang"
        :disabled-date="disabledRange"
    />
  </div>
</template>

<script>

import Moment from "moment";
import {mapActions, mapState} from 'vuex';

import DatePicker from "vue2-datepicker";
import 'vue2-datepicker/locale/ru';

export default {
    name: 'RequestsFilterByDate',
    components: {
        DatePicker,
    },
    data() {
        return {
            dates: [],
        };
    },
    computed: {
        ...mapState('user', [
            'user',
        ]),
        selectLang() {
            return this.user.lang;
        },
        select_dates() {
            return this.$t('withdrawal.select_dates');
        },
    },
    beforeMount() {
        this.setDateFromUrl();
    },
    methods: {
        ...mapActions('withdrawalRequests', [
            'fetchWithdrawalRequests',
        ]),
        disabledRange(date) {
            return date < new Date(2022, 0, 1) || date > new Date();
        },
        setDateFromUrl() {
            const dateFromUrl = this.$route.query.date;

            if (!dateFromUrl) {
                return false;
            }

            this.dates = dateFromUrl.split('to').map(date => new Date(date));
        },
        selectDates() {
            const {
                $route,
                $router,
                dates,
                fetchWithdrawalRequests,
            } = this;
            const dateFrom = Moment(dates[0]).format();
            const dateTo = Moment(dates[1])
                .add(23, 'hours')
                .add(59, 'minutes')
                .add(59, 'seconds')
                .format()
      ;

            fetchWithdrawalRequests({
                route: $route,
                router: $router,
                date: [dateFrom, dateTo],
                excludeParams: ['page'],
            });
        },
        clearDates() {
            const {
                $route,
                $router,
                fetchWithdrawalRequests,
            } = this;

            fetchWithdrawalRequests({
                route: $route,
                router: $router,
                date: [],
                excludeParams: ['page'],
            });
        },
    },
};

</script>

<style lang="scss" scoped>

.requests-filter-by-date {
  &__title {
    margin-bottom: 8px;
    font-size: var(--font-size-text-main);
    font-family: var(--font-family);
    line-height: var(--line-height);
    color: var(--black-200);
  }


  &__date::v-deep.mx-datepicker-range {
    width: 100%;
  }

  &__date ::v-deep .mx-input {
    height: 46px;
    background: #FFFFFF;
    border: 1px solid #F2F2F2;
    box-shadow: inset 0px 4px 20px rgba(0, 0, 0, 0.03);
    border-radius: 12px;
    font-family: var(--font-family);
    font-size: var(--font-size-text-main);
    line-height: var(--line-height);
    color: var(--black-200);
  }

  &__date ::v-deep .mx-icon-clear svg {
    width: 24px;
    height: 24px;
  }
}

</style>